// types
import { FieldType, IField } from 'types/graphql'
// utils
import { castArray } from 'lodash'

// a picklist response holds only option ids — { value: 'id' } or { value: ['id', 'id'] }
const getPickListValues = (value: any, field: IField) =>
  castArray(value).map((item: any) => {
    const optionId = item?.value ?? item

    return { value: optionId, label: field.options?.find((option) => option.id === optionId)?.label }
  })

// a lookup response already matches the select option shape — { value, label, entity }
const getLookupValues = (value: any) => castArray(value)

const joinLabels = (values: { label?: string }[]) =>
  values
    .map(({ label }) => label)
    .filter(Boolean)
    .join(', ')

export const getDisplayValue = (value: any, field: IField) => {
  switch (field.fieldType) {
    case FieldType.PickList: {
      return joinLabels(getPickListValues(value, field))
    }
    case FieldType.Lookup: {
      return joinLabels(getLookupValues(value))
    }
    default: {
      return value
    }
  }
}

export const getFieldValue = (result: any, field: IField) => {
  switch (field.fieldType) {
    case FieldType.PickList: {
      const values = getPickListValues(result.value, field)

      return field.multiple ? values : values[0]
    }
    case FieldType.Lookup: {
      const values = getLookupValues(result.value)

      return field.multiple ? values : values[0]
    }
    default: {
      return result.value
    }
  }
}
